import React, { Component } from 'react';
import { Row, Col } from 'antd';
import store from 'store';
import { connect } from 'dva';
import styles from './index.less';
import StepsBlock from './StepsBlock';
import Banner from '../../../components/Banner';

const ROUTE_MAP = [
  'step-one', 'step-two', 'step-three', 'step-four', 'step-five', 'step-six',
];

export function checkCurrentStepIsCorrect(props, currentStep) {
  try {
    const finishedStep = parseInt(store.get('finishedStep') || 0, 10);
    if (currentStep > finishedStep + 1) {
      props.history.push(`/register/basic/${ROUTE_MAP[finishedStep]}`);
      return false;
    }
  } catch (e) {
    //
  }
  return true;
}

export function saveFinishedStep(currentStep) {
  try {
    const finishedStep = parseInt(store.get('finishedStep') || 0, 10);
    if (currentStep > finishedStep) {
      store.set('finishedStep', currentStep);
    }
  } catch (e) {
    //
  }
}

export function clearStore() {
  store.clearAll();
}

@connect(state => ({
  ...state.register
}))
export default class App extends Component {
  render() {
    const { currentStep } = this.props;
    return (
      <div className={styles.basicContentWarpper}>
        <Banner title="新供应商注册" />
        <Row>
          <Col className="frame-wrapper">
            <div className={styles.content}>
              <StepsBlock currentStep={currentStep} />
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}
